import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { isAfter } from 'date-fns';
import { TermsContext } from '../components/contexts/TermsContext';

const RequireTerms = ({ termsToAccept, termsRoute, termsDocumentType, online }) => {
  const [termDocs] = useContext(TermsContext);

  //get this straight from localstorage to avoid redirection again since this wrapper is ran again after acceptance
  const user = window.localStorage.getItem('user')
    ? JSON.parse(window.localStorage.getItem('user'))
    : undefined;

  const acceptedTerms = user
    ? user?.terms_accepted
      ? user.terms_accepted.find((acceptedTerm) => acceptedTerm.product_name === termsToAccept)
      : undefined
    : undefined;

  const termDoc = termDocs.find((item) => item.type === termsDocumentType);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (termDoc && online) {
      if (!acceptedTerms) {
        navigate(termsRoute, { state: { from: location }, replace: true });
      }

      if (
        acceptedTerms &&
        isAfter(new Date(termDoc.last_publication_date), new Date(acceptedTerms.accepted_at))
      ) {
        navigate(termsRoute, { state: { from: location }, replace: true });
      }
    }
  }, [acceptedTerms, termDoc, navigate, location, termsRoute, online]);

  return <Outlet />;
};

export default RequireTerms;
